export default {
  moduleTitle: "المؤسسات",
  // Client accounts see this drawer parent tab as "إدارة الشركة" instead --
  // NavDrawer.tsx swaps to this key at render time for userType "customer",
  // a presentation-only override that never touches the static nav tree.
  moduleTitleClient: "إدارة الشركة",
  nav: {
    organization: "الشركة",
    companies: "الشركات",
    admins: "مسؤولو الحسابات",
    regions: "المناطق",
    branches: "الفروع",
    departments: "الأقسام",
    individuals: "الأفراد",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
    restore: "استعادة",
  },
  permissions: {
    core: "النواة",
    organizationManagement: "إدارة الشركات",
    companies: "الشركات",
    admins: "مسؤولو الحسابات",
    regions: "المناطق",
    branches: "الفروع",
    departments: "الأقسام",
    individuals: "الأفراد",
  },
  addCompany: "إضافة شركة",
  editCompany: "تعديل الشركة",
  companyFormSubtitle: "أدخل تفاصيل الشركة والمعلومات الأساسية",
  mainInformation: "المعلومات الأساسية",
  attachments: "المرفقات",
  listTitle: "الشركات",
  listSubtitle: "إدارة الشركات ومسؤولي حساباتها",
  header: {
    description: "تابع حالة الشركات والعقود والمستخدمين على منصة من مكان واحد.",
    platformAdmin: "مدير المنصة",
    accountAdmin: "مسؤول الحساب",
  },
  tabs: {
    companies: "الشركات",
    admins: "مسؤولو الحسابات",
  },
  toolbar: {
    add: "اضافه",
    archive: "الارشيف",
    search: "بحث",
    filters: "تصفية",
    clearFilters: "مسح التصفية",
  },
  stats: {
    title: "إحصاءات الشركات",
    accounts: "الشركات",
    active: "الشركات النشطة",
    inactive: "الشركات الغير نشطة",
    admins: "مسئولو الحسابات",
    loading: "جارٍ التحميل",
    error: "غير متاح",
  },
  filters: {
    title: "تصفية الشركات",
    type: "نوع الحساب",
    allTypes: "كل الأنواع",
    company: "شركة",
    individual: "فرد",
    createdAt: "تاريخ الإنشاء",
    createdAtPlaceholder: "اختر نطاقاً زمنياً",
    clearDateRange: "مسح النطاق الزمني",
    archivedAt: "تاريخ الأرشفة",
    archivedAtPlaceholder: "اختر نطاقاً زمنياً",
  },
  datePicker: {
    nextMonth: "الشهر التالي",
    previousMonth: "الشهر السابق",
  },
  table: {
    company: "الشركة",
    email: "البريد الإلكتروني",
    admin: "المسؤول",
    noAdmin: "لا يوجد مسؤول",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    archivedAt: "تاريخ الأرشفة",
    actions: "الإجراءات",
    empty: "لا توجد شركات مطابقة لهذه التصفية.",
    error: "تعذر تحميل الشركات.",
    loading: "جارٍ تحميل الشركات",
    showingCount: "عرض {{count}} من {{total}}",
    rowsPerPageLabel: "عرض الصفوف",
    nextPage: "الصفحة التالية",
    previousPage: "الصفحة السابقة",
    pagination: "ترقيم الصفحات",
    sortAscending: "ترتيب تصاعدي",
    sortDescending: "ترتيب تنازلي",
  },
  status: {
    active: "نشط",
    inactive: "غير نشط",
  },
  actionMenu: {
    trigger: "إجراءات الشركة",
  },
  form: {
    nameEn: "الاسم بالإنجليزية",
    nameAr: "الاسم بالعربية",
    email: "البريد الإلكتروني",
    phoneNumber1: "رقم الهاتف الأساسي",
    phoneNumber2: "رقم الهاتف الثانوي",
    countryCode: "رمز الدولة",
    countrySaudiArabia: "المملكة العربية السعودية",
    countryEgypt: "مصر",
    countryUnitedArabEmirates: "الإمارات العربية المتحدة",
    countryJordan: "الأردن",
    fax: "الفاكس",
    address: "العنوان",
    remarks: "ملاحظات",
    type: "نوع الحساب",
    typeCompany: "شركة",
    typeIndividual: "فرد",
    currency: "العملة",
    currencyPlaceholder: "اختر عملة",
    addAttachments: "إضافة مرفقات",
    dropzoneTitle: "اسحب الملفات هنا أو انقر للاستعراض",
    dropzoneHint:
      "PDF، DOC، XLS، PNG، JPG بحد أقصى 25 ميجابايت لكل ملف و10 ملفات",
    browseFiles: "استعراض الملفات",
    addAnotherAttachment: "إضافة مرفق آخر",
    removeAttachment: "إزالة المرفق",
    attachmentComplete: "مكتمل",
    attachmentPending: "بانتظار الرفع",
    fileSizeMb: "{{size}} ميجا",
    invalidType: "يُسمح فقط بملفات PDF وDOC وDOCX وXLS وXLSX وPNG وJPG.",
    tooLarge: "يجب ألا يتجاوز حجم كل ملف 25 ميجابايت.",
    tooMany: "يمكنك رفع 10 ملفات كحد أقصى.",
    cancel: "إلغاء",
    loading: "جارٍ تحميل الشركة",
    loadError: "تعذر تحميل الشركة.",
    empty: "لم يتم العثور على الشركة.",
    createSuccessFallback: "تم الإنشاء بنجاح",
  },
  detail: {
    loading: "جارٍ تحميل الشركة",
    error: "تعذر تحميل الشركة.",
    empty: "لم يتم العثور على الشركة.",
    notAvailable: "غير متاح",
    accountType: "نوع الحساب",
    currency: "العملة",
    admin: "مسؤول الحساب",
    title: "تفاصيل الشركة",
    backToCompanies: "العودة إلى الشركات",
    log: "سجل",
    companyName: "اسم الشركة",
    companyNumber: "رقم الشركة",
    noAttachments: "لا توجد مرفقات.",
    deleteTitle: "حذف الشركة",
    deleteDescription: "هل تريد حذف {{name}}؟ لا يمكن التراجع عن ذلك.",
    confirmDelete: "حذف الشركة",
    cancelDelete: "إلغاء",
    closeDelete: "إغلاق نافذة حذف الشركة",
  },
  deleteDialog: {
    title: "حذف",
    question: "هل أنت متأكد أنك تريد حذف هذه الشركة؟",
    warning: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
    confirmWord: "حذف",
    instruction: 'اكتب "{{word}}" لتأكيد الحذف',
    inputLabel: "تأكيد الحذف",
    cancel: "إلغاء",
    confirm: "حذف",
    close: "إغلاق نافذة الحذف",
  },
  adminDeleteDialog: {
    title: "حذف",
    question: "هل أنت متأكد أنك تريد حذف هذا المسؤول؟",
    warning: "سينتقل المسؤول إلى الأرشيف ويمكن استعادته لاحقاً.",
    confirmWord: "حذف",
    instruction: 'اكتب "{{word}}" لتأكيد الحذف',
    inputLabel: "تأكيد الحذف",
    cancel: "إلغاء",
    confirm: "حذف",
    close: "إغلاق نافذة الحذف",
  },
  restoreDialog: {
    title: "استعادة الشركة",
    question: "يوجد شركة بنفس المعلومات في أرشيف الشركات",
    prompt: "هل تريد استعادة هذه الشركة مرة أخرى؟",
    cancel: "إلغاء",
    confirm: "استعادة الشركة",
    close: "إغلاق نافذة الاستعادة",
    successFallback: "تمت استعادة الشركة بنجاح.",
  },
  archivedCompanies: {
    title: "أرشيف الشركات",
    subtitle: "الشركات التي تمت أرشفتها ويمكن استعادتها.",
    empty: "لا توجد شركات مؤرشفة مطابقة لهذه التصفية.",
  },
  restoreArchivedCompanyDialog: {
    title: "استعادة الشركة",
    question: "هل أنت متأكد من استعادة هذه الشركة؟",
    prompt: "ستصبح الشركة نشطة مرة أخرى ويمكن استخدامها في النظام.",
    cancel: "الغاء",
    confirm: "استعادة الشركة",
    close: "إغلاق نافذة الاستعادة",
    successFallback: "تمت استعادة الشركة بنجاح.",
    errorFallback: "تعذرت استعادة الشركة.",
  },
  regions: {
    list: {
      title: "إدارة المناطق",
      subtitle: "تسجيل وادارة مناطق الشركة",
    },
    toolbar: {
      add: "إضافة منطقة",
      archive: "الارشيف",
      search: "بحث",
      searchPlaceholder: "بحث...",
    },
    table: {
      name: "اسم المنطقه",
      empty: "لا توجد مناطق مطابقة لهذه التصفية.",
      error: "تعذر تحميل المناطق.",
      loading: "جارٍ تحميل المناطق",
      showingCount: "عرض {{count}} من أصل {{total}} المناطق",
      archivedAt: "تاريخ الأرشفة",
    },
    actionMenu: {
      trigger: "إجراءات المنطقة",
    },
    form: {
      addTitle: "إضافة منطقة جديدة",
      editTitle: "تعديل المنطقة",
      subtitle: "التفاصيل والمعلومات الاساسية",
      infoSectionTitle: "معلومات المنطقه",
      nameAr: "اسم المنطقه بالعربية",
      nameEn: "اسم المنطقه بالانجليزية",
      isActive: "حالة التفعيل",
      isActiveDescription:
        "المناطق غير النشطة تحتفظ ببياناتها لكن لا يمكن إسنادها للفروع بعد الآن.",
      toggleStatusDialog: {
        titleActivate: "تفعيل المنطقة",
        titleDeactivate: "إلغاء تفعيل المنطقة",
        questionActivate: "هل أنت متأكد أنك تريد تفعيل هذه المنطقة؟",
        questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذه المنطقة؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق نافذة تغيير الحالة",
      },
      // Offered when the create request matches an archived region.
      restoreDialog: {
        title: "استعادة المنطقة",
        question:
          "يوجد بالفعل منطقة تحتوي على نفس المعلومات ضمن المناطق المؤرشفة.",
        prompt: "هل ترغب في استعادة هذه المنطقة؟",
        cancel: "إلغاء",
        confirm: "استعادة المنطقة",
        close: "إغلاق نافذة الاستعادة",
        successFallback: "تمت استعادة المنطقة بنجاح.",
        errorFallback: "تعذرت استعادة المنطقة.",
      },
      mapSectionTitle: "تحديد المنطقة علي الخريطه",
      mapSectionSubtitle:
        "استخدم أدوات الرسم لتحديد الحدود الجغرافية للمنطقة بدقة",
      geometryRequired: "حدود المنطقة غير صالحة. يرجى رسم مضلع صالح.",
      geometryNotClosed: "يرجى إكمال حدود المنطقة قبل الحفظ.",
      geometrySelfIntersecting:
        "لا يمكن لحدود المنطقة أن تتقاطع مع نفسها. يرجى تعديل المضلع.",
      geometryZeroArea: "يجب أن تُحدِّد حدود المنطقة مساحةً صالحة.",
      cancel: "الغاء",
      loading: "جارِ تحميل المنطقة",
      loadError: "تعذر تحميل بيانات المنطقة.",
      createSuccessFallback: "تمت إضافة المنطقة بنجاح.",
      updateSuccessFallback: "تم تحديث المنطقة بنجاح.",
      back: "العودة إلى المناطق",
    },
    detail: {
      title: "تفاصيل المنطقة",
      loading: "جارِ تحميل المنطقة",
      error: "تعذر تحميل بيانات المنطقة.",
      empty: "لم يتم العثور على المنطقة.",
    },
    map: {
      draw: "رسم المضلع",
      edit: "تعديل المضلع",
      delete: "حذف المضلع",
      cutTool: "حذف النقاط",
      drawingHint:
        "انقر على الخريطة لإضافة نقاط، ثم انقر على نقطة البداية مرة أخرى لإغلاق الشكل (٣ نقاط على الأقل).",
      minPointsToast: "يجب أن يحتوي حد المنطقة على ثلاث نقاط على الأقل.",
    },
    archivedRegions: {
      title: "أرشيف المناطق",
      subtitle: "المناطق التي تمت أرشفتها ويمكن استعادتها.",
      empty: "لا توجد مناطق مؤرشفة مطابقة لهذه التصفية.",
      back: "العودة إلى المناطق",
      restore: "استعادة المنطقة",
      restoreDialog: {
        title: "استعادة المنطقة",
        question: "هل أنت متأكد من استعادة هذه المنطقة؟",
        prompt: "ستصبح المنطقة نشطة مرة أخرى ويمكن استخدامها في النظام.",
        cancel: "الغاء",
        confirm: "استعادة المنطقة",
        close: "إغلاق نافذة الاستعادة",
        successFallback: "تمت استعادة المنطقة بنجاح.",
        errorFallback: "تعذرت استعادة المنطقة.",
      },
    },
    archiveDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذه المنطقة؟",
      warning: "ستنتقل المنطقة إلى الأرشيف ويمكن استعادتها لاحقاً.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      confirm: "حذف",
      cancel: "الغاء",
      close: "إغلاق نافذة الحذف",
      successFallback: "تم حذف المنطقة بنجاح.",
      errorFallback: "تعذر حذف المنطقة.",
    },
  },
  branches: {
    list: {
      title: "إدارة الفروع",
      subtitle: "تسجيل و ادارة فروع الشركة",
    },
    toolbar: {
      add: "إضافة فرع",
      archive: "الأرشيف",
      search: "البحث عن فرع",
      searchPlaceholder: "بحث...",
    },
    table: {
      name: "اسم الفرع",
      empty: "لا توجد فروع مطابقة لهذه التصفية.",
      error: "تعذر تحميل الفروع.",
      loading: "جارٍ تحميل الفروع",
      showingCount: "عرض {{count}} من أصل {{total}} الفروع",
      archivedAt: "تاريخ الأرشفة",
    },
    actionMenu: {
      trigger: "إجراءات الفرع",
    },
    archiveDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا الفرع؟",
      warning: "سينتقل الفرع إلى الأرشيف ويمكن استعادته لاحقاً.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      confirm: "حذف",
      cancel: "الغاء",
      close: "إغلاق نافذة الحذف",
      successFallback: "تم حذف الفرع بنجاح.",
      errorFallback: "تعذر حذف الفرع.",
    },
    form: {
      addTitle: "إضافة فرع جديد",
      editTitle: "تعديل الفرع",
      subtitle: "التفاصيل والمعلومات الاساسية",
      infoSectionTitle: "معلومات الفرع",
      nameAr: "اسم الفرع بالعربية",
      nameEn: "اسم الفرع بالانجليزية",
      nameLabel: "اسم الفرع",
      account: "الحساب",
      accountPlaceholder: "اختر الحساب",
      isActive: "الحالة النشطة",
      isActiveDescription:
        "الفروع غير النشطة تحتفظ ببياناتها لكن لا يمكن إسنادها للأصول بعد الآن.",
      locationSectionTitle: "المواقع الجغرافية",
      country: "الدولة",
      countryPlaceholder: "اختر الدولة",
      governorate: "المحافظة",
      governoratePlaceholder: "اختر المحافظة",
      location: "موقع الفرع",
      locationPlaceholder: "موقع الفرع",
      pickLocation: "تحديد الموقع على الخريطة",
      cancel: "الغاء",
      loading: "جارِ تحميل الفرع",
      loadError: "تعذر تحميل بيانات الفرع.",
      createSuccessFallback: "تمت إضافة الفرع بنجاح.",
      updateSuccessFallback: "تم تحديث الفرع بنجاح.",
      saveFailed: "تعذر حفظ الفرع.",
      toggleStatusDialog: {
        titleActivate: "تفعيل الفرع",
        titleDeactivate: "إلغاء تفعيل الفرع",
        questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا الفرع؟",
        questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا الفرع؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق نافذة تغيير الحالة",
      },
      // Offered when the create request matches an archived branch.
      restoreDialog: {
        title: "استعادة الفرع",
        question:
          "يوجد بالفعل فرع يحتوي على نفس المعلومات ضمن الفروع المؤرشفة.",
        prompt: "هل ترغب في استعادة هذا الفرع؟",
        cancel: "إلغاء",
        confirm: "استعادة الفرع",
        close: "إغلاق نافذة الاستعادة",
        successFallback: "تمت استعادة الفرع بنجاح.",
        errorFallback: "تعذرت استعادة الفرع.",
      },
    },
    map: {
      title: "موقع الفرع",
      confirm: "تأكيد الموقع",
      close: "إغلاق",
    },
    detail: {
      title: "تفاصيل الفرع",
      locationSectionTitle: "الموقع الجغرافي",
      notAvailable: "غير متوفر",
      loading: "جارِ تحميل الفرع",
      error: "تعذر تحميل بيانات الفرع.",
      empty: "الفرع غير موجود.",
      backToBranches: "العودة إلى الفروع",
    },
    archivedBranches: {
      title: "أرشيف الفروع",
      subtitle: "الفروع التي تمت أرشفتها ويمكن استعادتها.",
      empty: "لا توجد فروع مؤرشفة مطابقة لهذه التصفية.",
    },
    restoreDialog: {
      title: "استعادة الفرع",
      question: "هل أنت متأكد من استعادة هذا الفرع؟",
      prompt: "سيصبح الفرع نشطًا مرة أخرى ويمكن استخدامه في النظام.",
      cancel: "الغاء",
      confirm: "استعادة الفرع",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تمت استعادة الفرع بنجاح.",
      errorFallback: "تعذرت استعادة الفرع.",
    },
  },
  departments: {
    title: "إدارة الأقسام",
    registered: "تسجيل و ادارة أقسام الشركة",
    search: "بحث...",
    toolbar: {
      add: "إضافة قسم",
      archive: "الأرشيف",
    },
    create: {
      breadcrumb: "إضافة قسم",
      title: "إضافة قسم جديد",
      subtitle: "أدخل بيانات القسم الجديد",
      back: "العودة إلى الأقسام",
      mainSection: "معلومات القسم",
      additionalSection: "معلومات إضافية",
      nameAr: "اسم القسم",
      nameEn: "اسم القسم",
      arabicTag: "بالعربية",
      englishTag: "بالانجليزية",
      remarks: "الملاحظات",
      optional: "(اختياري)",
      remarksPlaceholder: "الملاحظات",
      save: "حفظ",
      cancel: "إلغاء",
      successFallback: "تم إنشاء القسم بنجاح.",
      duplicate: "القسم موجود بالفعل",
      failure: "تعذر إنشاء القسم. يرجى المحاولة مرة أخرى.",
      // Offered when the create request matches an archived department.
      restoreDialog: {
        title: "استعادة القسم",
        question:
          "يوجد بالفعل قسم يحتوي على نفس المعلومات ضمن الأقسام المؤرشفة.",
        prompt: "هل ترغب في استعادة هذا القسم؟",
        cancel: "إلغاء",
        confirm: "استعادة القسم",
        close: "إغلاق نافذة الاستعادة",
      },
    },
    unsavedChanges: {
      title: "تغييرات غير محفوظة",
      message: "لديك تغييرات غير محفوظة. هل أنت متأكد من رغبتك في المغادرة؟",
      stay: "البقاء",
      leave: "المغادرة",
      close: "إغلاق النافذة",
    },
    actions: {
      trigger: "إجراءات القسم",
      view: "عرض التفاصيل",
      edit: "تعديل",
      delete: "حذف",
    },
    detail: {
      back: "العودة إلى الأقسام",
      subtitle: "التفاصيل والمعلومات الأساسية للقسم",
      section: "تفاصيل القسم",
      branch: "اسم الفرع",
      status: "حالة التفعيل",
      active: "نشط",
      inactive: "غير نشط",
      remarks: "ملاحظات",
      notAvailable: "غير متوفر",
      edit: "تعديل",
      loading: "جارٍ تحميل القسم",
      error: "تعذر تحميل القسم.",
    },
    edit: {
      back: "العودة إلى الأقسام",
      save: "حفظ التعديلات",
      status: "حالة التفعيل",
      statusActive: "القسم نشط",
      statusInactive: "القسم غير نشط",
      success: "تم تحديث القسم بنجاح.",
      failure: "تعذر تحديث القسم. يرجى المحاولة مرة أخرى.",
    },
    statusDialog: {
      title: "تغيير الحالة",
      message: "هل أنت متأكد من تغيير حالة القسم؟",
      note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
      yes: "نعم",
      no: "لا",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا القسم؟",
      warning: "سينتقل القسم إلى الأرشيف ويمكن استعادته لاحقاً.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      success: "تم حذف القسم ونقله إلى الأرشيف.",
    },
    archived: {
      back: "العودة إلى الأقسام",
      title: "الأقسام المؤرشفة",
      subtitle: "الأقسام التي تمت أرشفتها ويمكن استعادتها.",
      archivedAt: "تاريخ الأرشفة",
      empty: "لا توجد أقسام مؤرشفة مطابقة لهذا البحث.",
      restore: "استعادة",
    },
    restoreDialog: {
      title: "استعادة القسم",
      question: "هل أنت متأكد من استعادة هذا القسم؟",
      prompt: "سيصبح القسم نشطاً مرة أخرى وقابلاً للاستخدام في النظام.",
      cancel: "إلغاء",
      confirm: "استعادة القسم",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تمت استعادة القسم بنجاح.",
      errorFallback: "تعذرت استعادة القسم.",
    },
    table: {
      name: "اسم القسم",
      empty: "لا توجد أقسام مطابقة لهذا البحث.",
      error: "تعذر تحميل الأقسام.",
      loading: "جارٍ تحميل الأقسام",
    },
  },
};
